import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { MESSAGE_TYPE, USER_ROLE } from "constants/index";
import { TalentService, UpdateAdminSessionTimeOutService,
  TalentBulkMessageCreateData, TalentBulkMessageListData,
  TalentBulkMessageRetrieveData, TalentBulkMessagePauseCreateData, TalentBulkMessageUpdateData,
  UpdateAdminSessionTimeOutCreateData
 } from "api";
 import { resetAppState } from "../store/common";

// Add bulk message
export const saveBuldMessage = createAsyncThunk(
  "saveBuldMessage",
  async (data: TalentBulkMessageCreateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentBulkMessageCreate(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Update bulk message
export const updateBuldMessage = createAsyncThunk(
  "updateBuldMessage",
  async (data: TalentBulkMessageUpdateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentBulkMessageUpdate(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Save bulk message
export const getListBuldMessage = createAsyncThunk(
    "getListBuldMessage",
    async (data: TalentBulkMessageListData, thunkAPI: any) => {
      try {
        const res = await TalentService.talentBulkMessageList(data) as any;
        if (res) { return res; }
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      } catch (error: any) {
        return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
      }
    },
);

// Get bulk message detail
export const getBuldMessageDetail = createAsyncThunk(
    "getBuldMessageDetail",
    async (data: TalentBulkMessageRetrieveData, thunkAPI: any) => {
      try {
        const res = await TalentService.talentBulkMessageRetrieve(data) as any;
        if (res) { return res; }
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      } catch (error: any) {
        return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
      }
    },
);

// Pause bulk message
export const pauseBuldMessage = createAsyncThunk(
    "pauseBuldMessage",
    async (data: TalentBulkMessagePauseCreateData, thunkAPI: any) => {
      try {
        const res = await TalentService.talentBulkMessagePauseCreate(data) as any;
        if (res) { return res; }
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      } catch (error: any) {
        return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
      }
    },
);

// Extend session time out when add/update bulk messages
export const extendSessionTimeOut = createAsyncThunk(
  "extendSessionTimeOut",
  async (data: UpdateAdminSessionTimeOutCreateData, thunkAPI: any) => {
    try {
      const res = await UpdateAdminSessionTimeOutService.updateAdminSessionTimeOutCreate(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getIsDisabledBtnSend = (formData: any = {}, files: any[] = []) => (state: any) => {
  const { chatType, needNewFormData, isSaving } = state.bulkMessages;
  const { jobSelected } =  state.chatMessage;
  if ((chatType === MESSAGE_TYPE.SCOUT && !jobSelected?.id) || needNewFormData || isSaving) {
    return true;
  }
  if (!formData?.content?.trim() && !files.length) {
    return true
  }
  if (formData?.isPublicScheduled && (!formData.publicScheduleTime || !formData.publicScheduleHours || !formData.publicScheduleMinutes)) {
    return true
  }
  return false;
};


interface BulkMessagesState {
    recipients: [];
    chatType: string;
    isLoadingSaveSchedule: boolean;
    isLoadingGetSchedule: boolean;
    isLoadingGetBulkMessageDetail: boolean;
    actionStatus: string;
    actionName: string;
    resMessage: string;
    isSuccess: boolean;
    bulkingMessageList: any;
    bulkMessageDetail: any;
    countItems: number;
    currentPage: number;
    pageSize: number;
    sortBy: string | null;
    sortOrder: string | null;
    searchQuery: string | null;
    totalResults: number;
    isResetForm: boolean;
    viewDetail: boolean;
    needNewFormData: boolean;
    isSaving: boolean;
}

const initialState: BulkMessagesState = {
    recipients: [],
    chatType: MESSAGE_TYPE.COMPANY_DISCUSS,
    isLoadingSaveSchedule: false,
    isLoadingGetSchedule: false,
    isLoadingGetBulkMessageDetail: false,
    actionStatus: "idle",
    actionName: "",
    resMessage: '',
    isSuccess: true,
    bulkingMessageList: [],
    bulkMessageDetail: {},
    countItems: 0,
    currentPage: 1,
    pageSize: 10,
    sortBy: null,
    sortOrder: null,
    searchQuery: "",
    totalResults: 0,
    isResetForm: false,
    viewDetail: false,
    needNewFormData: false,
    isSaving: false,
}

export const bulkMessagesSlice = createSlice({
    name: 'bulkMessages',
    initialState,
    reducers: {
        setRecipients: (state, action) => {
            state.recipients = action.payload;
        },
        setChatType: (state, action) => {
            state.chatType = action.payload;
        },
        setActionStatus: (state, action) => { 
            state.actionStatus = action.payload; 
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setBulkingMessageList: (state, action) => {
          state.bulkingMessageList = action.payload;
        },
        setIsResetForm: (state, action) => {
          state.isResetForm = action.payload;
        },
        setBulkMessageDetail: (state, action) => {
          state.bulkMessageDetail = action.payload;
        },
        setViewDetail: (state, action) => {
          state.viewDetail = action.payload;
        },
        setNeedNewFormData: (state, action) => {
          state.needNewFormData = action.payload;
        },
        setIsSaving: (state, action) => {
          state.isSaving = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        // reset state
        .addCase(resetAppState, () => initialState)

        // Save bulk messages
        .addCase(saveBuldMessage.pending, (state) => {
            state.isLoadingSaveSchedule = true; 
            state.error = null;
            state.actionName = "saveBuldMessage"; 
            state.actionStatus = "pending"; 
        })
        .addCase(saveBuldMessage.fulfilled, (state, action) => {
            state.isLoadingSaveSchedule = false; 
            state.actionName = "saveBuldMessage";
            state.actionStatus = "fulfilled";
            state.resMessage = action.payload.message;
            state.isSuccess = action.payload.success;
            state.isSaving = false;
            if (!action.payload?.success) {
              state.needNewFormData = true;
            }
        })
        .addCase(saveBuldMessage.rejected, (state, action) => {
            state.isLoadingSaveSchedule = false; 
            state.actionName = "saveBuldMessage"; 
            state.actionStatus = "rejected"; 
        })

        // Update bulk messages
        .addCase(updateBuldMessage.pending, (state) => {
            state.isLoadingSaveSchedule = true; 
            state.error = null;
            state.actionName = "updateBuldMessage"; 
            state.actionStatus = "pending"; 
        })
        .addCase(updateBuldMessage.fulfilled, (state, action) => {
            state.isLoadingSaveSchedule = false; 
            state.actionName = "updateBuldMessage";
            state.actionStatus = "fulfilled";
            state.resMessage = action.payload.message;
            state.isSuccess = action.payload.success;
            state.isSaving = false;
            if (!action.payload?.success) {
              state.needNewFormData = true;
            }
        })
        .addCase(updateBuldMessage.rejected, (state, action) => {
            state.isLoadingSaveSchedule = false; 
            state.actionName = "updateBuldMessage"; 
            state.actionStatus = "rejected"; 
        })

        // Get list bulk messages
        .addCase(getListBuldMessage.pending, (state) => {
            state.isLoadingGetSchedule = true; 
            state.error = null;
            state.actionName = "getListBuldMessage"; 
            state.actionStatus = "pending"; 
        })
        .addCase(getListBuldMessage.fulfilled, (state, action) => {
            state.isLoadingGetSchedule = false; 
            state.actionName = "getListBuldMessage";
            state.actionStatus = "fulfilled";
            state.resMessage = action.payload.message;
            state.isSuccess = action.payload.success; 
            state.bulkingMessageList = action.payload.results?.data;
            state.totalResults = action.payload.results?.total_records;
            state.countItems = action.payload.count;
        })
        .addCase(getListBuldMessage.rejected, (state, action) => {
            state.isLoadingGetSchedule = false; 
            state.actionName = "getListBuldMessage"; 
            state.actionStatus = "rejected"; 
        })

        // Get bulk messages detail
        .addCase(getBuldMessageDetail.pending, (state) => {
            state.isLoadingGetBulkMessageDetail = true; 
            state.error = null;
            state.actionName = "getBuldMessageDetail"; 
            state.actionStatus = "pending"; 
        })
        .addCase(getBuldMessageDetail.fulfilled, (state, action) => {
            state.isLoadingGetBulkMessageDetail = false; 
            state.actionName = "getBuldMessageDetail";
            state.actionStatus = "fulfilled";
            state.resMessage = action.payload.message;
            state.isSuccess = action.payload.success; 
            state.bulkMessageDetail = action.payload.data; 
        })
        .addCase(getBuldMessageDetail.rejected, (state, action) => {
            state.isLoadingGetBulkMessageDetail = false; 
            state.actionName = "getBuldMessageDetail"; 
            state.actionStatus = "rejected"; 
        })

        // Pause bulk messages
        .addCase(pauseBuldMessage.pending, (state) => {
            state.error = null;
            state.actionName = "pauseBuldMessage"; 
            state.actionStatus = "pending"; 
        })
        .addCase(pauseBuldMessage.fulfilled, (state, action) => {
            state.actionName = "pauseBuldMessage";
            state.actionStatus = "fulfilled";
            state.resMessage = action.payload.message;
            state.isSuccess = action.payload.success; 
        })
        .addCase(pauseBuldMessage.rejected, (state, action) => {
            state.actionName = "pauseBuldMessage"; 
            state.actionStatus = "rejected"; 
        })

        // Extend session time out
        .addCase(extendSessionTimeOut.pending, (state) => {
            state.error = null;
            state.actionName = "extendSessionTimeOut"; 
            state.actionStatus = "pending"; 
        })
        .addCase(extendSessionTimeOut.fulfilled, (state, action) => {
            state.actionName = "extendSessionTimeOut";
            state.actionStatus = "fulfilled";
        })
        .addCase(extendSessionTimeOut.rejected, (state, action) => {
            state.actionName = "extendSessionTimeOut"; 
            state.actionStatus = "rejected"; 
        })
    },
});
const bulkMessagesActions = {
    ...bulkMessagesSlice.actions,
}
export {bulkMessagesActions}
export default bulkMessagesSlice.reducer;